import React from 'react';
import Icon from 'ui/Icon';
import {
    TriggerButton,
    // PlayTogether,
    // CombinationsCount,
} from 'features/BetBuddy/Mobile/styled';
// import getTexts from 'utils/localization';
// import { useSelector } from 'react-redux';
// import { isBetBuddySelectionsMode } from 'common/selectors/betSlipSelector';
// import combinationsCountSelector from 'common/selectors/combinationsCountSelector';
import useTrigger from 'features/BetBuddy/hooks/useTrigger.ts';

// const t = getTexts();

const Trigger = (props) => {
    // const isSelectionsMode = useSelector(isBetBuddySelectionsMode);
    // const combinationsCount = useSelector(combinationsCountSelector);

    const trigger = useTrigger();

    return (
        <TriggerButton onClick={trigger}>
            {/*{!props.isHorseSelected || isSelectionsMode ? (*/}
            {/*    <PlayTogether uppercase white condensed bold flex={'unset'}>*/}
            {/*        {isSelectionsMode && (*/}
            {/*            <CombinationsCount>*/}
            {/*                {combinationsCount}*/}
            {/*            </CombinationsCount>*/}
            {/*        )}{' '}*/}
            {/*        {t.bb.spilklub}*/}
            {/*    </PlayTogether>*/}
            {/*) : null}*/}
            <Icon ispilklub2 size="x07" color="white" />
        </TriggerButton>
    );
};

export default Trigger;
